<template>
    <div>
        <v-row>
            <!-- Eventually the users name will become a clickable link -->
            <v-col cols="12" md="1">
                <vote-control :parentItem="{id: parentId, data: null}" :commentMode="true" :commentItem="comment" :parentType="parentType"></vote-control> 
            </v-col>
            <v-col cols="12" md="11">
                <v-card-subtitle>Posted on {{comment.date}} by <b color="primary" @click="viewUserProfile(comment.owner)"> {{comment.ownerName}}</b></v-card-subtitle>
                <v-card-text>{{comment.commentText}}</v-card-text>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import VoteControl from './../Voting/VoteControl.vue';

export default {
    data () {
        return {
        }
    },
    components: {
        VoteControl
    },
    props: {
        comment: Object,
        parentId: String,
        parentType: String
    },
    computed: {
    },
    mounted(){
    },
    methods: {
        viewUserProfile(profileId){
            //This will just emit the profile id so that all firebase queries and transitions are done in the CommentsControl.vue
            this.$emit("viewUserProfile", profileId);
        }
    }
}
</script>